"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchFootprintSchema = void 0;
const zod_1 = require("zod");
const Footprint_1 = require("./Footprint");
const Pin_1 = require("./Pin");
exports.SchFootprintSchema = Footprint_1.FootprintSchema.extend({
    pins: zod_1.z.lazy(() => Pin_1.PinSchema.array()),
});
//# sourceMappingURL=SchFootprint.js.map